import { ErrorCode, useDropzone } from 'react-dropzone';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';

const PRICE_LIST_MAX_SIZE = 1e7; // 10 MB

const priceListFileFormats = {
    'text/csv': ['.csv'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};

export const usePriceListDropzone = (onFileDrop: (file: File) => void) => {
    const { addErrorToast } = useToasts();

    return useDropzone({
        onDrop: (files) => {
            if (files.length > 0) {
                onFileDrop(files[0]);
            }
        },
        onDropRejected: (rejections) => {
            const firstError = rejections[0]?.errors[0]?.code as ErrorCode | undefined;

            let firstErrorTranslation = translate('attachments.toast.invalidFilesError.unknownError');

            if (firstError) {
                switch (firstError) {
                    case ErrorCode.FileInvalidType:
                        firstErrorTranslation = translate('attachments.toast.invalidFilesError.invalidFileFormat');
                        break;
                    case ErrorCode.FileTooLarge:
                        firstErrorTranslation = translate('attachments.toast.invalidFilesError.invalidFileSize');
                        break;
                    case ErrorCode.TooManyFiles:
                        firstErrorTranslation = translate(
                            'attachments.toast.invalidFilesError.multipleFilesNotAllowed'
                        );
                        break;
                }
            }

            addErrorToast(firstErrorTranslation);
        },
        multiple: false,
        noClick: true,
        maxSize: PRICE_LIST_MAX_SIZE,
        maxFiles: 1,
        accept: priceListFileFormats,
    });
};
